import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@otp-session/shared';
import './App.css';
import './styles/iframe-card-display.css';
import CardViewRequestPage from './pages/CardViewRequestPage';
import HomePage from './pages/HomePage';
import { useDirection } from './hooks/useDirection';
import i18n from './i18n';

function AppContent() {
  return (
    <Router
      basename="/card-view"
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/01234567890123456789012345678901" element={<CardViewRequestPage />} />
        <Route path="/card-view-request/:cvrt" element={<CardViewRequestPage />} />
        <Route path="/:cvrt" element={<CardViewRequestPage />} />
      </Routes>
    </Router>
  );
}

function App() {
  // Automatically set HTML dir attribute based on current language
  useDirection();

  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={<div>Loading...</div>}>
        <AppContent />
      </Suspense>
    </I18nextProvider>
  );
}

export default App;